export default "__VITE_ASSET__D8u0MK5F__"